import { render, staticRenderFns } from "./BtnImageSelect.vue?vue&type=template&id=6beafddc&scoped=true"
import script from "./BtnImageSelect.vue?vue&type=script&lang=js"
export * from "./BtnImageSelect.vue?vue&type=script&lang=js"
import style0 from "./BtnImageSelect.vue?vue&type=style&index=0&id=6beafddc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6beafddc",
  null
  
)

export default component.exports